import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Document, Page, pdfjs } from 'react-pdf';

import { searchProductBarcodeValue, downloadBarcodePreview } from '../../redux/actions/products';
import { indexBarcodeTemplates, previewBarcodeTemplate, getTemplateFungibles, getTemplateLineSettings } from '../../redux/actions/barcodeTemplates';

import LoadingSpinner from '../partials/LoadingSpinner';
import LoadingPlaceholder from '../partials/LoadingPlaceholder';
import NoLabelTemplatesBox from '../partials/NoLabelTemplatesBox';
import RequiresRefreshBanner from '../partials/RequiresRefreshBanner';

import { Page as ShopifyPage, BlockStack, Card, Select, Text, Divider, DescriptionList, Box, Button } from '@shopify/polaris';
import {
  SaveIcon
} from '@shopify/polaris-icons';

const BarcodeActions = ({ shopUrl, payload, getByBarcodeValue, getTemplates, activeBarcode, barcodeTemplates, loadPreview, downloadPreview, downloadUrl, products, templateFungibles, templateLineSettings, loadFungibles, loadLineSettings, requiresRefresh }) => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.mjs`;
  
  let { barcodeValue } = useParams();

  const [activeTemplate, setActiveTemplate] = useState({});
  const [templateOptions, setTemplateOptions] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [downloadSubmitted, setDownloadSubmitted] = useState(false);

  useEffect(() => {
    getTemplates(shopUrl, payload);
    getByBarcodeValue(shopUrl, payload, barcodeValue);
  }, []);

  useEffect(() => {
    if(downloadUrl && downloadSubmitted) { 
      setDownloadSubmitted(false); 
      let win = window.open(downloadUrl, '_blank');
      win.focus();
    }
  }, [downloadUrl]);

  const switchActiveTemplate = (event) => {
    let template = barcodeTemplates.templates.find(template => template.uuid === event);

    loadFungibles(shopUrl, payload, event);
    loadLineSettings(shopUrl, payload, event);

    setActiveTemplate(template);
  }

  useEffect(() => {
    let options = [];

    barcodeTemplates.templates.forEach((template) => {
      let optionMap = {};
      optionMap['label'] = template.template_name;
      optionMap['value'] = template.uuid;

      options.push(optionMap);
    });

    setTemplateOptions(options);
  }, [barcodeTemplates])

  useEffect(() => {
    if(templateFungibles && templateLineSettings && barcodeTemplates.fungiblesLoaded && barcodeTemplates.lineSettingsLoaded && (Object.keys(activeTemplate).length > 0)) {
      let updatedTemplate = activeTemplate;
      updatedTemplate['barcode_enabled'] = templateFungibles[activeTemplate['barcode_element_uuid']]['enabled'];
      updatedTemplate['barcode_line'] = templateFungibles[activeTemplate['barcode_element_uuid']]['line'];
      updatedTemplate['barcode_symbol_enabled'] = templateFungibles[activeTemplate['barcode_symbol_element_uuid']]['enabled'];
      updatedTemplate['barcode_symbol_line'] = templateFungibles[activeTemplate['barcode_symbol_element_uuid']]['line'];
      updatedTemplate['barcode_symbol_priority'] = templateFungibles[activeTemplate['barcode_symbol_element_uuid']]['priority'];
      updatedTemplate['barcode_symbol_label_enabled'] = templateFungibles[activeTemplate['barcode_symbol_element_uuid']]['label_enabled'];
      updatedTemplate['barcode_symbol_label_override'] = templateFungibles[activeTemplate['barcode_symbol_element_uuid']]['label_override'];

      updatedTemplate['sku_enabled'] = templateFungibles[activeTemplate['sku_element_uuid']]['enabled'];
      updatedTemplate['sku_line'] = templateFungibles[activeTemplate['sku_element_uuid']]['line'];
      updatedTemplate['sku_priority'] = templateFungibles[activeTemplate['sku_element_uuid']]['priority'];
      updatedTemplate['sku_label_enabled'] = templateFungibles[activeTemplate['sku_element_uuid']]['label_enabled'];
      updatedTemplate['sku_label_override'] = templateFungibles[activeTemplate['sku_element_uuid']]['label_override'];

      updatedTemplate['product_name_enabled'] = templateFungibles[activeTemplate['product_name_element_uuid']]['enabled'];
      updatedTemplate['product_name_line'] = templateFungibles[activeTemplate['product_name_element_uuid']]['line'];
      updatedTemplate['product_name_priority'] = templateFungibles[activeTemplate['product_name_element_uuid']]['priority'];
      updatedTemplate['product_name_label_enabled'] = templateFungibles[activeTemplate['product_name_element_uuid']]['label_enabled'];
      updatedTemplate['product_name_label_override'] = templateFungibles[activeTemplate['product_name_element_uuid']]['label_override'];
      updatedTemplate['option_1_enabled'] = templateFungibles[activeTemplate['option_1_element_uuid']]['enabled'];
      updatedTemplate['option_1_line'] = templateFungibles[activeTemplate['option_1_element_uuid']]['line'];
      updatedTemplate['option_1_priority'] = templateFungibles[activeTemplate['option_1_element_uuid']]['priority'];
      updatedTemplate['option_1_label_enabled'] = templateFungibles[activeTemplate['option_1_element_uuid']]['label_enabled'];
      updatedTemplate['option_1_label_override'] = templateFungibles[activeTemplate['option_1_element_uuid']]['label_override'];
      updatedTemplate['option_2_enabled'] = templateFungibles[activeTemplate['option_2_element_uuid']]['enabled'];
      updatedTemplate['option_2_line'] = templateFungibles[activeTemplate['option_2_element_uuid']]['line'];
      updatedTemplate['option_2_priority'] = templateFungibles[activeTemplate['option_2_element_uuid']]['priority'];
      updatedTemplate['option_2_label_enabled'] = templateFungibles[activeTemplate['option_2_element_uuid']]['label_enabled'];
      updatedTemplate['option_2_label_override'] = templateFungibles[activeTemplate['option_2_element_uuid']]['label_override'];
      updatedTemplate['option_3_enabled'] = templateFungibles[activeTemplate['option_3_element_uuid']]['enabled'];
      updatedTemplate['option_3_line'] = templateFungibles[activeTemplate['option_3_element_uuid']]['line'];
      updatedTemplate['option_3_priority'] = templateFungibles[activeTemplate['option_3_element_uuid']]['priority'];
      updatedTemplate['option_3_label_enabled'] = templateFungibles[activeTemplate['option_3_element_uuid']]['label_enabled'];
      updatedTemplate['option_3_label_override'] = templateFungibles[activeTemplate['option_3_element_uuid']]['label_override'];
      updatedTemplate['price_enabled'] = templateFungibles[activeTemplate['price_element_uuid']]['enabled'];
      updatedTemplate['price_line'] = templateFungibles[activeTemplate['price_element_uuid']]['line'];
      updatedTemplate['price_priority'] = templateFungibles[activeTemplate['price_element_uuid']]['priority'];
      updatedTemplate['price_label_enabled'] = templateFungibles[activeTemplate['price_element_uuid']]['label_enabled'];
      updatedTemplate['price_label_override'] = templateFungibles[activeTemplate['price_element_uuid']]['label_override'];
      updatedTemplate['brand_enabled'] = templateFungibles[activeTemplate['brand_element_uuid']]['enabled'];
      updatedTemplate['brand_line'] = templateFungibles[activeTemplate['brand_element_uuid']]['line'];
      updatedTemplate['brand_priority'] = templateFungibles[activeTemplate['brand_element_uuid']]['priority'];
      updatedTemplate['brand_label_enabled'] = templateFungibles[activeTemplate['brand_element_uuid']]['label_enabled'];
      updatedTemplate['brand_label_override'] = templateFungibles[activeTemplate['brand_element_uuid']]['label_override'];

      updatedTemplate['line_settings'] = templateLineSettings;

      setActiveTemplate(updatedTemplate);

      loadPreview(shopUrl, payload, updatedTemplate, activeBarcode);
    }
  }, [templateFungibles, templateLineSettings]);

  const handleDownload = () => {
    setDownloadSubmitted(true);
    downloadPreview(shopUrl, payload);
  }

  const items = () => {
    let allItems =
    [
      {
        term: 'Barcode Value',
        description:
          `${activeBarcode.barcode}`
      },
      {
        term: 'SKU',
        description:
          `${activeBarcode.sku}`
      },
      {
        term: 'Product',
        description:
          `${activeBarcode.displayName}`
      }
    ]

    activeBarcode.selectedOptions.map(option =>
      allItems.push({
        term: option.name,
        description: option.value
      })
    )

    return allItems;
  }

  if(barcodeTemplates.status === 'success' && products.status === 'success' && activeBarcode) {
    return(
      <ShopifyPage
        title="Preview Labels"
        backAction={{content: 'Back', url: 'https://' + window.location.hostname + '/manage' + window.location.search}}
      >
        { requiresRefresh &&
          <RequiresRefreshBanner />
        }
        <Card>
          <BlockStack gap="500">
            { barcodeTemplates.templates.length > 0 && barcodeTemplates.status === 'success' &&
              <>
                <Select
                  label="Template"
                  options={templateOptions}
                  onChange={switchActiveTemplate}
                  value={activeTemplate?.uuid}
                  placeholder="Select a template to preview"
                />
              </>
            }

            { barcodeTemplates.status === 'success' && barcodeTemplates.templates.length === 0 && 
              <NoLabelTemplatesBox />
            }

            <Text variant="headingXl" as="h4">Preview</Text>
            <Box background="bg-surface-info" padding="400">
              { (Object.keys(activeTemplate).length > 0) && barcodeTemplates.previewUri &&
                  <Document className="pdf-document" file={{ url: barcodeTemplates.previewUri }} loading={<LoadingSpinner size="small" statusText="Loading Preview" />}>
                    <Page
                      className="pdf-page"
                      pageNumber={1} 
                      renderTextLayer={false}
                      renderAnnotationLayer={false}
                    />
                  </Document>
              }
              { (Object.keys(activeTemplate).length === 0) &&
                <Text tone="subdued">Select template to preview</Text>
              }
              { !barcodeTemplates.previewUri && (Object.keys(activeTemplate).length > 0) &&
                <LoadingSpinner />
              }

            </Box>
            { !downloadSubmitted && (Object.keys(activeTemplate).length > 0) && <Button icon={SaveIcon} className="btn btn-primary btn-medium top-15" onClick={() => handleDownload()}>Download Preview</Button> }

            <Divider borderColor="border-inverse" />

            <DescriptionList
              items={items()}
            />

          </BlockStack>
        </Card>
      </ShopifyPage>
    )
  }

  return(
    <ShopifyPage
      title="Preview Labels"
      backAction={{content: 'Back', url: 'https://' + window.location.hostname + '/manage' + window.location.search}}
    >
      <LoadingPlaceholder />
    </ShopifyPage>
  )
}

const mapStateToProps = state => ({
  requiresRefresh: state.activeToken.requiresRefresh,
  products: state.products,
  searchedBarcodes: state.products.searchedBarcodes,
  barcodeTemplates: state.barcodeTemplates,
  activeBarcode: state.products.activeBarcode,
  downloadUrl: state.products.downloadUrl,
  templateFungibles: state.barcodeTemplates.templateFungibles,
  templateLineSettings: state.barcodeTemplates.templateLineSettings,
});

const mapDispatchToProps = (dispatch) => ({
  getByBarcodeValue: (shopUrl, payload, barcodeValue) => dispatch(searchProductBarcodeValue(shopUrl, payload, barcodeValue)),
  getTemplates: (shopUrl, payload) => dispatch(indexBarcodeTemplates(shopUrl, payload)),
  loadPreview: (shopUrl, payload, options, values) => dispatch(previewBarcodeTemplate(shopUrl, payload, options, values)),
  downloadPreview: (shopUrl, payload) => dispatch(downloadBarcodePreview(shopUrl, payload)),
  loadFungibles: (shopUrl, payload, uuid) => dispatch(getTemplateFungibles(shopUrl, payload, uuid)),
  loadLineSettings: (shopUrl, payload, uuid) => dispatch(getTemplateLineSettings(shopUrl, payload, uuid)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BarcodeActions);  